import { useMediaQuery } from 'react-responsive'

import { MAX_MOBILE_DISPLAY_SIZE } from '~/constants'

export const isMobileDisplay = () =>
  useMediaQuery({
    query: `(max-width: ${MAX_MOBILE_DISPLAY_SIZE}px)`,
  })
